import uuid from 'uuid/v4';

export default uuid;
